import { ordersAPI } from '~/services/api';

type AppcuesResponse = {
  token: string;
};

const getAppcuesSignature = () =>
  ordersAPI.request<AppcuesResponse>({
    method: 'GET',
    url: '/appcues/jwt',
  });

export { getAppcuesSignature };
